<template>
  <div ref="scrollparent">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-card v-if="survey">
      <!-- <pre>{{survey}}</pre> -->
      <v-row wrap>
        <!-- Audit info's -->
        <v-col cols="12" lg="7">
          <h1
            class="mb-8"
            v-html="survey.info[`title_${$i18n.locale}`]"
          ></h1>
          <v-layout
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
          >
            <v-flex xs12 md4 mb-7>
              <h2 class="mb-2">{{ $tc("final-report.indice-1", 1, {score: percentSurveyProgress}) }}</h2>
              <small>{{ $t("final-report.indice-label-1") }}</small>
            </v-flex>

            <v-flex xs12 md4 mb-7>
              <h2 class="mb-2">{{ $tc("final-report.indice-2", 1, {score: survey.done.point}) }}</h2>
              <small>{{ $t("final-report.indice-label-2") }}</small>
            </v-flex>

            <v-flex xs12 md4 mb-7>
              <h2 class="mb-2">{{ $tc("final-report.indice-3", 1, {score: survey.total.requiredpt}) }}</h2>
              <small>{{ $t("final-report.indice-label-3") }}</small>
            </v-flex>
          </v-layout>
        </v-col><!-- Audit info's -->

        <v-col cols="12" lg="5"><!-- Firm info's -->
            <IDCard
              v-if="survey.info.firm_name"
              class="instruction"
              :title="survey.info.firm_name"
              :address="survey.info.firm_address ? survey.info.firm_address : null"
              :city="survey.info.firm_city ? survey.info.firm_city : null"
              :zip="survey.info.firm_zip ? survey.info.firm_zip : null"
              :vat="survey.info.firm_vat ? survey.info.firm_vat : null"
              :nr="survey.info.firm_nr ? survey.info.firm_nr : null"
              :reg="survey.info.firm_reg ? survey.info.firm_reg : null"
              noEdit
            ></IDCard>
            <IDCard v-else></IDCard>
        </v-col><!-- Firm info's -->
      </v-row>

      <v-divider></v-divider>

      <v-row wrap class="mt-5 mt-md-8">
        <!-- Sticky col -->
        <v-col
          cols="12"
          md="5"
          order-md="2"
          v-scroll="onScroll"
          ref="sticky"
          class="sticky-nav">

          <InspectorNav v-if="survey" class="mb-4" :survey="survey"></InspectorNav>

          <div class="box">
            <v-layout
              d-block
              d-md-flex
              row
              ma-0
              align-center
              justify-space-between
              class="box-header px-5 px-md-6"
            >
              <h3>{{ $t("edit-audit-screen.navigation-box-title") }}</h3>
            </v-layout>
            <div class="box-content flex px-6 px-md-8">
              <div
                v-for="sequence in survey.sequences"
                :key="sequence.id"
                class="flex row align-center justify-space-between"
              >
                <span class="row ma-0 mb-4 mb-md-0 pa-0">
                  <v-icon
                    size="15px"
                    class="col-1 mr-2"
                    color="secondary">icon-directory</v-icon>
                  <button
                    class="subtitle-1 link pa-0 pa-md-2 mb-1 col-10 text-left"
                    @click="$vuetify.goTo(`#${
                          sequence[`title_${$i18n.locale}`] !== '' &&
                          sequence[`title_${$i18n.locale}`] !== undefined &&
                          sequence[`title_${$i18n.locale}`] !== 'undefined' &&
                          sequence[`title_${$i18n.locale}`] !== null &&
                          sequence[`title_${$i18n.locale}`] !== 'null' ? makeId(sequence[`title_${$i18n.locale}`]) :
                          sequence['title_en'] !== '' &&
                          sequence['title_en'] !== undefined &&
                          sequence['title_en'] !== 'undefined' &&
                          sequence['title_en'] !== null &&
                          sequence['title_en'] !== 'null' ? makeId(sequence['title_en']) :
                          sequence['title_fr'] !== '' &&
                          sequence['title_fr'] !== undefined &&
                          sequence['title_fr'] !== 'undefined' &&
                          sequence['title_fr'] !== null &&
                          sequence['title_fr'] !== 'null' ? makeId(sequence['title_fr']) : makeId(sequence['title_nl'])}`)"
                    v-html="sequence[`title_${$i18n.locale}`] !== '' &&
                            sequence[`title_${$i18n.locale}`] !== undefined &&
                            sequence[`title_${$i18n.locale}`] !== 'undefined' &&
                            sequence[`title_${$i18n.locale}`] !== null &&
                            sequence[`title_${$i18n.locale}`] !== 'null' ? sequence[`title_${$i18n.locale}`] :
                            sequence['title_en'] !== '' &&
                            sequence['title_en'] !== undefined &&
                            sequence['title_en'] !== 'undefined' &&
                            sequence['title_en'] !== null &&
                            sequence['title_en'] !== 'null' ? sequence['title_en'] :
                            sequence['title_fr'] !== '' &&
                            sequence['title_fr'] !== undefined &&
                            sequence['title_fr'] !== 'undefined' &&
                            sequence['title_fr'] !== null &&
                            sequence['title_fr'] !== 'null' ? sequence['title_fr'] : sequence['title_nl']"
                  ></button>
                </span>
                <!-- <small>Max. {{  }}</small> -->
              </div>
            </div>
          </div>
        </v-col><!-- Sticky col --><!-- Sticky col -->

        <!-- Display Sequences and the question to it -->
        <v-col cols="12" md="7">
          <transition-group name="fade">
            <div
              v-for="(sequence, index) in survey.sequences"
              :key="`sequences-${index}`"
              class="mb-12"
              :id="sequence[`title_${$i18n.locale}`] !== '' &&
                  sequence[`title_${$i18n.locale}`] !== undefined &&
                  sequence[`title_${$i18n.locale}`] !== 'undefined' &&
                  sequence[`title_${$i18n.locale}`] !== null &&
                  sequence[`title_${$i18n.locale}`] !== 'null' ? makeId(sequence[`title_${$i18n.locale}`]) :
                  sequence['title_en'] !== '' &&
                  sequence['title_en'] !== undefined &&
                  sequence['title_en'] !== 'undefined' &&
                  sequence['title_en'] !== null &&
                  sequence['title_en'] !== 'null' ? makeId(sequence['title_en']) :
                  sequence['title_fr'] !== '' &&
                  sequence['title_fr'] !== undefined &&
                  sequence['title_fr'] !== 'undefined' &&
                  sequence['title_fr'] !== null &&
                  sequence['title_fr'] !== 'null' ? makeId(sequence['title_fr']) : makeId(sequence['title_nl'])"
            >
              <SequenceBox
                :answerid="$route.params.answerid"
                :sequence="sequence"
                noButton
                showQuestion
                inspector
                :status="survey.info.status"
                @updateAllSeq="updateVetted"
                class="mb-8"
              ></SequenceBox>

            </div>
          </transition-group>
        </v-col><!-- Display Sequences and the question to it -->
      </v-row>

    </v-card>
  </div>
</template>

<script>
import { showSequence } from '@/js/survey/showSequence'
// import { getFirm } from '@/js/firm/getFirm'
import IDCard from '@/components/firm/IDCard'
import SequenceBox from '@/components/audits/survey/SequenceBox'
import InspectorNav from '@/components/audits/InspectorNav'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  components: {
    IDCard: IDCard,
    SequenceBox: SequenceBox,
    InspectorNav: InspectorNav,
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      survey: null,
      firm: null,
      httpalert: false
    }
  },

  created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return
    this.loadSeq()
    // this.loadFirm()
  },

  methods: {
    loadSeq () {
      const params = {
        answerid: this.$route.params.answerid,
        path: this.$route.params.sequenceid,
        sequenceid: this.$route.params.sequenceid,
        key: this.$route.params.validkey
      }
      showSequence(params)
        .then(response => {
          this.survey = response
          this.tab = {
            type: 'sequence',
            object: response.sequences[0]
          }
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    // loadFirm () {
    //   getFirm(this.$store.state.auth.token)
    //     .then(response => {
    //       response.forEach(firm => {
    //         console.log(this.$route.params.firmid)
    //         console.log(firm.id)
    //         if (firm.id === this.$route.params.firmid) {
    //           this.firm = firm
    //           return
    //         } else return
    //       })
    //     })
    //     .catch(() => {
    //       this.httpalert = true
    //       setTimeout(() => {
    //         this.httpalert = false
    //       }, 4000)
    //     })
    // },

    onScroll () {
      if (this.$vuetify.breakpoint.name === 'xs' ||
          this.$vuetify.breakpoint.name === 'sm') {

        this.$refs.sticky.style.transform = 'translateY(0px)'
        return
      }
      // this.offsetTop = e.target.scrollTop
      const sticky = this.$refs.sticky
      const offsetTop = window.pageYOffset || document.documentElement.scrollTop

      if (offsetTop > sticky.offsetTop) {
        // console.log(this.$refs.scrollparent.offsetTop)
        if (((offsetTop - sticky.offsetTop - 100) + sticky.offsetHeight) >= (this.$refs.scrollparent.offsetHeight - 100)) return
        // (offsetTop - sticky.offsetTop - 100) + 
        sticky.style.transform = `translateY(${offsetTop - sticky.offsetTop - 100}px)`
      }
      else {
        sticky.style.transform = 'translateY(0px)'
      }
    },

    updateVetted () {
      this.loadSeq()
    },

    makeId (value) {
      return value.replace(/\W/g,'_')
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  },

  computed: {
    percentSurveyProgress () {
      let percentProgress
      if (parseInt(this.survey.total.point) > 0) {
        percentProgress = Math.round((parseInt(this.survey.done.point) / parseInt(this.survey.total.point)) * 100)
      } else {
        percentProgress = 0
      }
      return percentProgress
    }
  }
}
</script>
